// SPDX-License-Identifier: AGPL-3.0-or-later

export interface ApiErrorBody {
  error: { code: string; message: string; details?: unknown };
}

export class ApiError extends Error {
  status: number;
  code: string;
  details?: unknown;
  constructor(status: number, body: ApiErrorBody) {
    super(body.error.message);
    this.status = status;
    this.code = body.error.code;
    this.details = body.error.details;
  }
}

export interface RequestInitJson extends Omit<RequestInit, 'body'> {
  body?: unknown;
}

export async function apiFetch<T>(path: string, init: RequestInitJson = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body !== undefined && !(init.body instanceof FormData)) {
    headers.set('content-type', 'application/json');
  }
  const { body: _omitBody, ...restInit } = init;
  const requestInit: RequestInit = {
    ...restInit,
    headers,
    credentials: 'same-origin',
  };
  if (init.body !== undefined) {
    requestInit.body = init.body instanceof FormData ? init.body : JSON.stringify(init.body);
  }
  const res = await fetch(path, requestInit);
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  const json: unknown = text.length === 0 ? undefined : JSON.parse(text);
  if (!res.ok) {
    const body =
      typeof json === 'object' && json !== null && 'error' in json
        ? (json as ApiErrorBody)
        : { error: { code: 'unknown_error', message: res.statusText } };
    throw new ApiError(res.status, body);
  }
  return json as T;
}
